import React, { CSSProperties } from 'react'
import Text, { Password } from './Text'
import Number from './Number'
import DateDetails from './Date'
import Header from './Header'
import Table from './Table'
import Files from './Files'
import Label from './Label'

interface Props {
  onSubmit?: (item: any) => void
  onKeyPress?: (e: any) => void
}
interface Children {
  children: React.ReactNode
  style?: React.CSSProperties
}
interface RowProps {
  label?: string
  required?: boolean
}

const Details = ({ children, onSubmit, onKeyPress }: Props & Children) => (
  <form onSubmit={onSubmit} onKeyPress={onKeyPress} className="details">
    {children}
  </form>
)
const Columns = ({ children }: Children) => <div className="details__columns">{children}</div>
const Column = ({ children, style }: Children) => (
  <div className="details__column" style={style}>
    {children}
  </div>
)
const Row = ({ children, label, required }: RowProps & Children) => (
  <div className="details__row">
    {label && (
      <div className="details__label-container">
        <Label required={required} label={label} />
      </div>
    )}
    {children}
  </div>
)
const Footer = ({ children, style }: { children: React.ReactNode; style?: CSSProperties }) => (
  <div style={style} className="details__footer">
    {children}
  </div>
)

Details.Column = Column
Details.Columns = Columns
Details.Footer = Footer
Details.Row = Row
Details.Text = Text
Details.Password = Password
Details.Number = Number
Details.Date = DateDetails
Details.Header = Header
Details.Table = Table
Details.Files = Files
Details.Label = Label
export default Details
